import { render } from "./video.vue?vue&type=template&id=5f83c7c0"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xurshid\\PROJECTS\\fvvga\\sayt\\vue_asosiy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__